import { memo, useCallback, useEffect, useMemo, useState } from 'react';

import { Image, Skeleton, Swiper } from '@bonanza-social/moonlight';
import useBanners from '../hooks/useBanners';

import { useIsFocused, useNavigation } from '@bonanza-social/navigation';
import { useDispatch } from '@bonanza-social/toolkit/state';
import { launchGame } from '@bonanza-social/games/state';

function Banners() {
  const navigation = useNavigation();
  const isFocused = useIsFocused();
  const [hasBeenFocused, setHasBeenFocused] = useState(false);
  const dispatch = useDispatch();
  const { banners, bannersDataState } = useBanners();

  const items = useMemo(
    () => banners.map((item) => ({ image: item.imageUrl })),
    [banners],
  );

  const onClick = useCallback(
    (index: number) => {
      const banner = banners[index];

      if (banner?.promotionId) {
        const promoType = banner.promoType === 'InPeriod' ? 'quests' : 'promos';

        if (
          banner.promoType === 'Referral' ||
          banner.subPromoType === 'Referral'
        ) {
          navigation.navigate('InviteFriends');
        } else if (promoType === 'quests') {
          navigation.navigate('QuestDetails', {
            id: banner.promotionId,
          });
        } else {
          navigation.navigate('PromoDetails', { id: banner.promotionId });
        }
      } else if (banner?.cta?.type) {
        switch (banner.cta.type) {
          case 'LaunchGame':
            if (banner.cta.gameId) {
              const gameId = banner.cta.gameId;
              dispatch(launchGame({ id: gameId }));
            }
            break;

          case 'NavigationLobby':
            navigation.navigate('Games');
            break;

          case 'NavigationPromotions':
            navigation.navigate('Promos');
            break;

          case 'NavigationRegister':
            navigation.navigate('RegistrationScreen');
            break;

          case 'NavigationRewards':
            navigation.navigate('Rewards');
            break;

          case 'NavigationReferral':
            navigation.navigate('Account', { path: '/invite' });
            break;

          default:
            break;
        }
      }
    },
    [banners, dispatch, navigation],
  );

  useEffect(() => {
    if (banners.length) {
      banners.forEach((banner) => {
        Image.prefetch(banner.imageUrl);
      });
    }
  }, [banners]);

  useEffect(() => {
    if (isFocused) {
      setHasBeenFocused(true);
    }
  }, [isFocused]);

  if (bannersDataState !== 'fulfilled' || !hasBeenFocused) {
    return <Skeleton width="100%" aspectRatio={16 / 9} />;
  }

  return (
    <Swiper
      items={items}
      width="100%"
      aspectRatio={2}
      autoplay
      pagination
      onClick={onClick}
      imageContentFit="cover"
    />
  );
}

export default memo(Banners);
